<template>
  <Transition name="modal">
    <div
      class="modal"
      :theme="theme"
      :class="[`modal-${id}`]"
      v-if="show"
      data-lenis-prevent
    >
      <FocusTrap :active="show">
        <TheSmoothScroll :useWrapper="true">
          <div
            class="underlay desktop-only"
            @click="onCloseClick"
          />
          <div class="pad">
            <div class="wrapper">
              <div class="head">
                <TheLogo
                  class="logo"
                  v-if="showLogo"
                />
                <ButtonIcon
                  icon="close"
                  size="large"
                  theme="white"
                  @click="onCloseClick"
                />
              </div>
              <div class="content">
                <slot />
              </div>
            </div>
          </div>
        </TheSmoothScroll>
      </FocusTrap>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { FocusTrap } from "focus-trap-vue"
// import IconLogo from "@/icons/logo-small.svg?component"

const props = defineProps({
  id: {
    required: true,
  },
  showLogo: {
    default: false,
  },
  theme: {
    default: false,
  },
})

const emits = defineEmits([])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const env = useEnv()

const refRoot = ref(null)

const onCloseClick = () => {
  app.setModalId(null)
}

const show = computed(() => {
  return app.modalId == props.id
})

watch(
  () => show.value,
  () => {
    // console.log(100, "Modal.show", show.value)
    app.setScrollPaused(show.value)

    // if (env.isMobile) {
    //   document.documentElement.style.overflow = show.value ? "clip" : ""
    //   document.body.style.overflow = show.value ? "clip" : ""
    // }
  }
)
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.modal {
  @include fill(fixed);
  width: calc(100%);
  z-index: 3000;

  --cl-bg1: var(--cl-gray-purple);
  --cl-bg2: color-mix(in srgb, var(--cl-black), 30% transparent);
  --cl-text: var(--cl-light);
}

.underlay {
  @include fill;
  position: fixed;
  background: rgba(0, 0, 0, 0.59);
  backdrop-filter: blur(20px);
}

.pad {
  padding-block: $p6;
  padding-inline: 4.2rem;
  @include flex(row, flex-end, center);
}

.wrapper {
  position: relative;
  width: 65.8rem;
  max-width: 100%;
  height: 100%;

  border-radius: 2rem;
  overflow-y: auto;
  @include flex(column, flex-start, stretch);

  backdrop-filter: blur(20px);

  // background: rgba(255, 255, 255, 0.2);
}

.head {
  @include flex(row, space-between, center);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 2rem;
  z-index: 2;
  // height: var(--nav-height);

  .modal-menu & {
    padding-left: 4rem;
  }

  .logo {
    width: 15rem;
  }

  .button-close {
    background: var(--cl-bg2);
  }
}

.content {
  flex: 1;
}

.modal-enter-active {
  transition: all 0.5s ease;

  .underlay {
    transition: all 0.4s ease;
  }

  .wrapper {
    transition: all 0.5s ease;
  }
}

.modal-leave-active {
  transition: all 0.3s ease;

  .underlay {
    transition: all 0.3s ease;
  }

  .wrapper {
    transition: all 0.3s ease;
  }
}

.modal-enter-from,
.modal-leave-to {
  .underlay {
    opacity: 0;
  }
  .wrapper {
    transform: translateX(-10%);
    opacity: 0;
  }
}

@include mobile {
  .modal {
    padding: 0;
  }

  .modal-menu {
    .pad {
      padding: 0;
    }

    .wrapper {
      width: 100%;
      height: 100lvh;
      padding-bottom: calc(env(safe-area-inset-bottom));
    }

    .head {
      padding-left: 2rem;
    }
  }

  .wrapper {
    // width: 65.8rem;
    border-radius: 0;
  }

  .head {
    .logo {
      width: 14.3rem;
    }

    .button-close {
      width: 3.2rem;

      .icon {
        width: 2rem;
      }
    }
  }
}
</style>
